export default __webpack_public_path__ + "static/media/Oleksandr_Leushchenko.9e9df324.png";